import {TimelineMax,gsap} from 'gsap';


export let headerTextTimeline = new TimelineMax({
    paused: true
});


headerTextTimeline.fromTo('.headerText--title ',2,
    {
        opacity:0,

    },
    {
        opacity:1
    })
